import prepareComponent from "@bluframe/grapple/prepareComponent"
import { PreviewMASResponse } from "@bluframe/mightychroma-mightytool-frontend-types"
import { FormEventHandler, RefObject, useRef } from "react"

import Item from "./Item"

export interface Props {
  isAdd?: boolean
  isPreviewLoading: boolean
  isSubmitLoading: boolean
  item?: PreviewMASResponse
  onCancel: () => void

  onPreview: (imdbId: string) => void

  onSubmit: (imdbId: string) => void
}

export interface ComponentProps extends Omit<Props, "onPreview" | "onSubmit"> {
  imdbIdRef: RefObject<HTMLInputElement | null>
  onPreview: () => void
  onSubmit: FormEventHandler
}

const usePrepareComponent = (props: Props): ComponentProps => {
  const imdbIdRef = useRef<HTMLInputElement>(null)

  const onSubmit: FormEventHandler = (event) => {
    event.preventDefault()

    if (!imdbIdRef.current) {
      return
    }

    props.onSubmit(imdbIdRef.current.value)
  }

  const onPreview = () => {
    if (!imdbIdRef.current) {
      return
    }
    props.onPreview(imdbIdRef.current.value)
  }

  return {
    ...props,
    imdbIdRef,
    onPreview,
    onSubmit
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Item
)
